module.exports = __webpack_public_path__ + "img/q21.36fbab51.png";